export const JobStatusCategories = {
    successful: ['installed', 'active', 'successful', 'done', 'timed'],
    running: ['creating', 'inProgress', 'new', 'ordered', 'blocked', 'running', 'pending', 'restart'],
    failed: ['failed', 'error'],
    support: ['support'],
    abort: ['abort']
};
